import { Alert, Platform } from 'react-native';

// Confirmation destructive compatible Web (levé de MoPCal, FT 52).
// React Native Web n'implémente pas Alert.alert multi-boutons (les boutons et
// leurs callbacks sont ignorés) → sur le web on utilise window.confirm.
export function confirmerSuppression(titre, message, onConfirmer, { texteConfirmer = 'Supprimer' } = {}) {
  if (Platform.OS === 'web') {
    const ok = (typeof window !== 'undefined' && window.confirm)
      ? window.confirm(message || titre)
      : true;
    if (ok) onConfirmer?.();
    return;
  }
  Alert.alert(titre, message, [
    { text: 'Annuler', style: 'cancel' },
    { text: texteConfirmer, style: 'destructive', onPress: () => onConfirmer?.() },
  ]);
}

// Choix multiple compatible Web (ex. récurrences : « cette occurrence » /
// « toutes les occurrences » / annuler). `boutons` = même tableau que pour
// Alert.alert : [{ text, style?, onPress? }]. Sur le web, où window.confirm est
// binaire, on enchaîne une confirmation par action (la 1re acceptée gagne) ;
// les boutons style 'cancel' ne sont pas proposés.
export function confirmerChoix(titre, message, boutons = []) {
  if (Platform.OS === 'web') {
    const actions = boutons.filter(b => b.style !== 'cancel');
    const annuler = boutons.find(b => b.style === 'cancel');
    const prefixe = message ? message + '\n\n' : '';
    for (const b of actions) {
      const ok = (typeof window !== 'undefined' && window.confirm)
        ? window.confirm(`${prefixe}${b.text} ?`)
        : false;
      if (ok) { b.onPress?.(); return; }
    }
    annuler?.onPress?.();
    return;
  }
  Alert.alert(titre, message, boutons);
}
